import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, Spinner, Form } from 'react-bootstrap'
import { checkUser } from '../Network/Authentication'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faUserCircle
} 
from '@fortawesome/free-solid-svg-icons'
import { Doughnut, Pie } from 'react-chartjs-2';
import { getDashboard, todayWidget, filterDashboard } from '../Network/Dashboard'
import { listCompany } from '../Network/Company'
import { NotifyContext } from '../Library/Notify'
import { Container } from '../Library'
import { LanguageContext } from '../Language/LanguageContext'
import { RoleContext } from '../Role/RoleContext'
import dayjs from 'dayjs'
import { setDocumentTitle } from '../AppTitle'

import Widget from '../Home/Widget'
import StatSection from '../Home/StatSection'
import TaskSection from '../Home/TaskSection'
import LatestNewsSection from '../Home/LatestNewsSection'
import UserActivity from '../Home/UserActivity'
import UpcommingSection from '../Home/UpcommingSection'
import DashboardVisitor from '../Visitor/Dashboard'
import DashboardListSpare from '../ListSpare/Dashboard'

import "./Monitor.css"
import { NetworkLockedOutlined } from '@material-ui/icons'

function MonitorScreen() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.sidebar
    const role = useContext(RoleContext)
    const notifyCx = useContext(NotifyContext)
    const [isLoading, setLoading] = useState(false)
    const [dashboardData, setData] = useState({
        itemNumber: {news: 0, events: 0},
        user:{active: 0, inactive: 0},
        upcomingEvent: null,
        lastestNews: [],
        task: {
            cancel: 0,
            in_progress: 0,
            waiting: 0,
            create: 0,
            complete: 0
        }
    });
    const [companyList, setCompanylist] = useState([]);
    const [chooseCompany, setChooseCompany] = useState();

    const fetchDashboard = () =>{
        setLoading(true)
        let companyId = null
        if(!role.checkPermission("NEWS_", "SET_COMPANY")){
            companyId = parseInt(localStorage.getItem("company_id"))
        }
        getDashboard(companyId,  
            (data)=>{
                setData(data)
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
                notifyCx.showNotify("Something wrong", error.message, 2)
            }
        )
        listCompany(
            (data)=>{
                setChooseCompany(data[0].id)
                setCompanylist(data)
                setLoading(false)
            }, 
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )
    }

    useEffect(()=>{
        setDocumentTitle("Monitor")
        listCompany(
            (data)=>{
                setChooseCompany(data[0].id)
                setCompanylist(data)
                setLoading(false)
            }, 
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )
        fetchDashboard()
        console.log(chooseCompany)
        return ()=>{
            fetchDashboard()
        }
    },[1000])

    return (
        <Container id="home" topbarTitle={lang.home}>
            <Row>
                <Col lg={6}>
                    {/*
                    <UserSection/>*/}
                    <StatSection
                    isLoading={isLoading}
                    newsCount={dashboardData.itemNumber.news}
                    userCount={dashboardData.user.active + dashboardData.user.inactive}
                    eventCount={dashboardData.itemNumber.events}
                    />
                    { role.checkPermission("_MENU_", "app.calendar") ?
                    <UpcommingSection
                    event={dashboardData.upcomingEvent}
                    isLoading={isLoading}
                    />
                    : null
                    }
                    { role.checkPermission("_MENU_", "app.my_task_list") ?
                    <TaskSection
                    isLoading={isLoading}
                    tasks={dashboardData.task}
                    />
                    : null
                }
                </Col>
                <Col lg={6}>
                    {/* role.checkPermission("_MENU_", "app.weather") 
                    || role.checkPermission("_MENU_", "app.air_pollution")
                    || role.checkPermission("_MENU_", "app.covid")
                    ?
                    <Widget/>
                    : null*/
                    }
                    <UserActivity
                    isLoading={isLoading}
                    active={dashboardData.user.active}
                    inactive={dashboardData.user.inactive}
                    />
                    { role.checkPermission("_MENU_", "app.news_list") ?
                    <LatestNewsSection
                    isLoading={isLoading}
                    news={dashboardData.lastestNews}
                    />
                    : null
                    }
                </Col>
            </Row>
            <hr/>
            {   role.checkPermission("_MENU_", "app.my_task_list") || role.checkPermission("_MENU_", "app.admin_visitor") ?
                <Row style={{ marginBottom:'20px', justifyContent:'center' }}>
                    <Form.Control as="select" value={chooseCompany} onChange={(e)=>setChooseCompany(e.target.value)} style={{ width:'50%' }}>
                                    {
                                    companyList.map((item, key) =>
                                    <option value={item.id} key={key}>{item.name}</option>
                                    )
                                    }
                    </Form.Control>
                </Row>
                : null
            }
                {
                    role.checkPermission("_MENU_", "app.my_task_list") && role.checkPermission("_MENU_", "app.admin_visitor") ?
                        <Row>
                            <Col>
                                <DashboardListSpare 
                                company={chooseCompany}
                                />
                            </Col>
                            <Col>
                                <DashboardVisitor 
                                company={chooseCompany}
                                />
                            </Col>
                        </Row>
                    : role.checkPermission("_MENU_", "app.my_task_list") ? 
                        <Row>
                            <DashboardListSpare 
                            company={chooseCompany}
                            />
                        </Row> 
                    : role.checkPermission("_MENU_", "app.admin_visitor") ?
                        <Row>
                            <DashboardVisitor 
                            company={chooseCompany}
                            />
                        </Row> 
                    : null
                }

                {/*
                <Col>
                { role.checkPermission("_MENU_", "app.my_task_list") ?
                    <DashboardListSpare 
                    company={chooseCompany}
                    />
                    : null
                }
                </Col>
                <Col>
                { role.checkPermission("_MENU_", "app.admin_visitor") ?
                    <DashboardVisitor 
                    company={chooseCompany}
                    />
                    : null  
                }
                </Col>
                */}
        </Container>
    )
}

function UserSection(){
    const [isLoading, setLoading] = useState(false)
    const [userInfo, setUserInfo] = useState({
        profileImagePath: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        position: ""
    })

    const fetchData = () =>{
        setLoading(true)
        checkUser(
            (data)=>{
                setLoading(false)
                setUserInfo(data.user)
            },
            (error)=>{
                setLoading(false)
            }
        )
    }

    useEffect(()=>{
        fetchData()
    },[])

    return(
        <div className="user-section section">
            { isLoading ?
            <div className="loading-section">
                <Spinner 
                variant="primary" 
                animation="border"
                size="sm"
                />
            </div> : null
            }
            <div className="info-container">
                <div className="image-container">
                    { userInfo.profileImagePath !== "" ?
                    <img src={userInfo.profileImagePath} className="image"/>
                    : <FontAwesomeIcon icon={faUserCircle} className="placeholder"/>
                    }
                </div>
                <div className="name-title">{userInfo.firstName + " " + userInfo.lastName}</div>
                <div className="description">
                    <div>{userInfo.email}</div>
                    <div>{userInfo.phone}</div>
                    <div>{userInfo.position}</div>
                </div>
            </div>
        </div>
    )
}

export default MonitorScreen
